import { writable, get } from 'svelte/store';
import * as util from '../js/util.js';

function createMyStore() {
    const { subscribe, set, update } = writable({});
    var gettingTexts = false;
    var timeOut = null;
    var getKeys = [];
    return {
        subscribe, update,
        setLang: async (lang) => {
            if (lang) {
                update(n => Object.assign(n, { langName: lang.langName, langisRtl: lang.isRtl, locale:lang.locale }))
                await langTextStore.getAllTexts(lang)
                if (lang.isRtl) {
                    document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl')
                    document.getElementsByTagName('html')[0].classList.add("rtl")
                } else {
                    document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr')
                    document.getElementsByTagName('html')[0].classList.remove("rtl")
                }
            }
           
        },
        getAllTexts: async (lang) => {
            if (lang == null) return;
            if (!gettingTexts) {
                gettingTexts = true;

                const json = await util.fetchJson('api/Lang/getalltexts?lang=' + lang.langName);
                var itemToAdd = {};
                itemToAdd[lang.langName.toLowerCase()] = json;
                update(n => Object.assign(n, itemToAdd))
                gettingTexts = false;
            }
        },
        getText: (langKey) => {
            if (gettingTexts) {
                window.setTimeout(() => { langTextStore.getText(langKey) }, 500);
                return '';
            } else {
                return langTextStore.getTextInternal(langKey)

            }
        },
        getTextInternal: (langKey, langName) => {
            langKey = langKey.toLowerCase()
            var store = get(langTextStore);
            var langName = store.langName;
            if (langName == null) return ''
            langName = langName.toLowerCase()
            var store = get(langTextStore);
            if (store[langName] && store[langName][langKey]) {
                return store[langName][langKey];
            }
            if (!getKeys.some(k => k == langKey)) {
                getKeys.push(langKey)
            }
            clearTimeout(timeOut);
            timeOut = window.setTimeout(() => {

                util.fetchJsonWithMethod('POST', 'api/Lang/GetTextsMultiple', { langName: langName, keys: getKeys }).then((items) => {
                    getKeys = []
                    var existing = {}
                    if (store[langName] != null) {
                        existing = store[langName]
                    }
                    store[langName] = { ...existing, ...items }
                    var itemToAdd = {};
                    itemToAdd[langName] = store[langName];
                    itemToAdd.getText = store.getText;
                    update(n => Object.assign(n, itemToAdd))
                });
            }, 300);
            return ' '
            // util.fetchPlain('api/Lang/gettext?langName=' + langName + '&langKey=' + langKey).then((txt) => {
            //     store[langName][langKey] = txt;
            //     var itemToAdd = {};
            //     itemToAdd[langName] = store[langName];
            //     itemToAdd.getText = store.getText;
            //     update(n => Object.assign(n, itemToAdd))
            // });
        }

    };
}
export const langTextStore = createMyStore();
util.fetchJson('api/lang/getlangs').then(async (allLangs) => {
    langTextStore.update(n => Object.assign(n, { allLangs: allLangs }))
    var store = get(langTextStore)
    if (store && store.langName == null && allLangs && allLangs.length >0 ) {
        await langTextStore.setLang(allLangs.find(l => l.isDefault))
    }
})
langTextStore.update(n => Object.assign(n, { getText: langTextStore.getText, allLangs: [], langName: null }))